import TriangleContent from "../../components/shared/TriangleCells/TriangleContent/TriangleContent";
import { useMemo } from "react";

import TriangleInputChild from "./TriangleInputChild";

interface Props {
  id: string;
  value: string | Record<string, string>;
  triangleHeaders?: string[];
  maxWidth: string | undefined;
  suffix?: string;
}

const TriangleInput = ({
  id,
  value,
  triangleHeaders,
  maxWidth,
  suffix,
}: Props) => {
  const triangles = useMemo(() => {
    if (!triangleHeaders) return new Array(2).fill(0).map((_, i) => i);
    return triangleHeaders;
  }, [triangleHeaders]);

  const defaultValue = useMemo(() => {
    if (typeof value === "string") {
      return triangles?.reduce(
        (acc, header) => {
          acc[header] = "";
          return acc;
        },
        {} as Record<string, string>,
      );
    }
    return value;
  }, [value, triangles]);

  const inputs = useMemo(() => {
    return triangles.map(header => (
      <TriangleInputChild
        suffix={suffix}
        id={`${id}.${header}`}
        maxWidth={maxWidth}
        defaultValue={defaultValue?.[header]}
      />
    ));
  }, [defaultValue, triangles, suffix]);
  return (
    <TriangleContent data={inputs} minHeight={70} isInput minWidth={120} />
  );
};
export default TriangleInput;
